export const reasons = [
  {
    icon: "ri-map-pin-2-line",
    title: "春日部市の地域密着",
    text: "春日部市を中心に、越谷市・さいたま市など近隣地域に対応。会社から近い地域のお客様を大切に、できる限りスピーディーに対応します。",
  },
  {
    icon: "ri-building-2-line",
    title: "建設・リフォーム会社が運営",
    text: "屋根工事・塗装工事を中心に住宅リフォームを行う株式会社小林建設が運営。会社所在地・ホームページ・施工実績もご確認いただけます。",
  },
  {
    icon: "ri-route-line",
    title: "片付けからリフォームまで一貫対応",
    text: "片付け業者・内装業者・リフォーム会社へ別々に頼む必要はありません。片付けからその後の原状回復・リフォームまで、窓口を一本化できます。",
  },
  {
    icon: "ri-hand-coin-line",
    title: "見積もり無料・原則追加料金なし",
    text: "お見積もりは無料です。見積もり時に確認した作業内容から変更がなければ、原則として追加料金は発生しません。",
  },
  {
    icon: "ri-flashlight-line",
    title: "スピーディーな対応",
    text: "大きな会社ではありませんが、その分お客様との距離が近く、問い合わせや現地確認など、できる限り早く対応することを大切にしています。",
  },
  {
    icon: "ri-award-line",
    title: "建設業許可を取得済み",
    text: "建設業許可（屋根工事・板金工事）を取得した会社が運営しています。住宅工事の経験を活かしたサービスをご提供します。",
  },
];